module.exports = __webpack_public_path__ + "static/media/1_02.57d8b32a.jpg";